<template>
  <el-main class="not-found" v-loading="isLoading">
    <img class="center-block logo" data-qa="Content-Logo-Image" :src="imageSrc">
    <el-col :xs="20" :sm="16" :md="16" :lg="8" class="main">
      <div class="title">{{ $t('notFoundTitle') }}</div>
      <div class="description">
        {{ $t('notFoundDescription') }}
      </div>
      <div class="buttons-block">
        <a :href="goSupportPage">
          <el-button class="support-button" type="primary" :style="{ '--button-color': backgroundColor }">
            {{ $t('notFoundButtonSupportText') }}
          </el-button>
        </a>
      </div>
    </el-col>
  </el-main>
</template>

<script>
  import main from './NotFound.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './NotFound.scss'
</style>



// WEBPACK FOOTER //
// NotFound.vue?82871d84